<template lang="pug">
.landing-user-registration
  .form
    p {{ $t('landing.selectInsuranceType') }}
    .insurances-wrap
      .insurance-card(
        v-for="(insObj, index) in insuranceTypes"
        :key="insObj.ins_id"
        @click="setSelectedInsurance(insObj)"
      )
        //- this is a hack, needs to be fixed when a better idea comes up idk
        .svg-holder(
          v-if="index === 0"
          :class="{ 'selected' : selectedInsurance && insObj.ins_id === selectedInsurance.ins_id }"
        )
          <svg width="78" height="60" viewBox="0 0 78 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M37.6656 15.5656L12.8982 35.9049V57.8569C12.8982 58.4253 13.1247 58.9704 13.5278 59.3723C13.9308 59.7742 14.4775 60 15.0476 60L30.1012 59.9612C30.6694 59.9583 31.2133 59.7313 31.6141 59.3297C32.0149 58.9281 32.2398 58.3846 32.2398 57.8181V44.9983C32.2398 44.4299 32.4663 43.8848 32.8694 43.4829C33.2725 43.081 33.8192 42.8552 34.3892 42.8552H42.9867C43.5567 42.8552 44.1034 43.081 44.5065 43.4829C44.9096 43.8848 45.136 44.4299 45.136 44.9983V57.8087C45.1352 58.0907 45.1901 58.3701 45.2977 58.6309C45.4053 58.8917 45.5635 59.1287 45.7632 59.3284C45.9629 59.5281 46.2001 59.6866 46.4613 59.7947C46.7225 59.9028 47.0026 59.9585 47.2854 59.9585L62.3337 60C62.9037 60 63.4504 59.7742 63.8535 59.3723C64.2566 58.9704 64.483 58.4253 64.483 57.8569V35.8902L39.721 15.5656C39.4299 15.3316 39.0672 15.204 38.6933 15.204C38.3194 15.204 37.9568 15.3316 37.6656 15.5656ZM76.7882 29.3899L65.5577 20.1598V1.60732C65.5577 1.18103 65.3879 0.772205 65.0856 0.470774C64.7832 0.169343 64.3732 0 63.9457 0H56.4229C55.9954 0 55.5853 0.169343 55.283 0.470774C54.9807 0.772205 54.8109 1.18103 54.8109 1.60732V11.333L42.7838 1.46668C41.6296 0.519673 40.1813 0.00189308 38.6866 0.00189308C37.1919 0.00189308 35.7435 0.519673 34.5894 1.46668L0.585029 29.3899C0.421795 29.5244 0.286744 29.6897 0.187594 29.8763C0.0884436 30.0629 0.0271368 30.2671 0.00717641 30.4773C-0.012784 30.6875 0.0089933 30.8996 0.0712639 31.1014C0.133535 31.3032 0.235078 31.4909 0.370092 31.6535L3.79565 35.8058C3.93029 35.969 4.09591 36.1042 4.28301 36.2035C4.47012 36.3029 4.67503 36.3645 4.88604 36.3847C5.09704 36.405 5.30998 36.3836 5.51267 36.3217C5.71536 36.2598 5.90382 36.1587 6.06726 36.0241L37.6656 10.0739C37.9568 9.83993 38.3194 9.71234 38.6933 9.71234C39.0672 9.71234 39.4299 9.83993 39.721 10.0739L71.3207 36.0241C71.4839 36.1587 71.672 36.26 71.8744 36.3221C72.0768 36.3842 72.2895 36.4059 72.5004 36.386C72.7112 36.3661 72.916 36.3049 73.1032 36.2061C73.2903 36.1072 73.4561 35.9726 73.591 35.8098L77.0165 31.6575C77.1514 31.4939 77.2525 31.3054 77.314 31.1026C77.3756 30.8999 77.3963 30.6871 77.3751 30.4764C77.3539 30.2657 77.2911 30.0612 77.1904 29.8747C77.0897 29.6883 76.953 29.5235 76.7882 29.3899Z" fill="#EFEFF8"/>
          </svg>

        .svg-holder(
          v-if="index === 1"
          :class="{ 'selected' : selectedInsurance && insObj.ins_id === selectedInsurance.ins_id }"
        )
          <svg width="65" height="60" viewBox="0 0 65 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M44.1015 18.9505H39.8317V13.7822H44.1015V9.47525H49.2252V13.7822H53.495V18.9505H49.2252V23.2574H44.1015V18.9505ZM46.6634 0L33 5.16832V15.66C33 24.36 38.824 32.4743 46.6634 34.4554C54.5027 32.4743 60.3267 24.36 60.3267 15.66V5.16832L46.6634 0Z" fill="#5446E4"/>
            <path d="M63.1613 46.2729C65.17 44.7719 65.5988 41.9073 64.1205 39.8677C62.6422 37.8281 59.821 37.3927 57.8123 38.8937L44.3043 49H30.6948C29.7017 49 28.8892 48.175 28.8892 47.1667C28.8892 46.1583 29.7017 45.3333 30.6948 45.3333H39.7227C41.7201 45.3333 43.3338 43.6948 43.3338 41.6667C43.3338 39.6385 41.7201 38 39.7227 38H21.8587C18.5749 38 15.3925 39.1344 12.8309 41.2083L7.76397 45.3333H3.61115C1.61373 45.3333 0 46.9719 0 49V56.3333C0 58.3615 1.61373 60 3.61115 60H39.7791C43.0517 60 46.2453 58.9344 48.886 56.9635L63.1726 46.2729H63.1613ZM21.7459 45.3333H21.8475H21.7459Z" fill="#5446E4"/>
          </svg>

        .svg-holder(
          v-if="index === 2"
          :class="{ 'selected' : selectedInsurance && insObj.ins_id === selectedInsurance.ins_id }"
        )
          <svg width="67" height="60" viewBox="0 0 67 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.1053 28.4211L26.8421 14.2105H55.2632L60 28.4211M55.2632 44.2105C54.0069 44.2105 52.802 43.7115 51.9137 42.8231C51.0254 41.9348 50.5263 40.73 50.5263 39.4737C50.5263 38.2174 51.0254 37.0126 51.9137 36.1242C52.802 35.2359 54.0069 34.7368 55.2632 34.7368C56.5194 34.7368 57.7243 35.2359 58.6126 36.1242C59.5009 37.0126 60 38.2174 60 39.4737C60 40.73 59.5009 41.9348 58.6126 42.8231C57.7243 43.7115 56.5194 44.2105 55.2632 44.2105ZM26.8421 44.2105C25.5858 44.2105 24.381 43.7115 23.4927 42.8231C22.6043 41.9348 22.1053 40.73 22.1053 39.4737C22.1053 38.2174 22.6043 37.0126 23.4927 36.1242C24.381 35.2359 25.5858 34.7368 26.8421 34.7368C28.0984 34.7368 29.3032 35.2359 30.1916 36.1242C31.0799 37.0126 31.5789 38.2174 31.5789 39.4737C31.5789 40.73 31.0799 41.9348 30.1916 42.8231C29.3032 43.7115 28.0984 44.2105 26.8421 44.2105ZM59.7474 12.6316C59.0842 10.7368 57.2842 9.47368 55.2632 9.47368H26.8421C24.8211 9.47368 23.0211 10.7368 22.3579 12.6316L15.7895 31.5789V56.8421C15.7895 57.6796 16.1222 58.4829 16.7144 59.0751C17.3066 59.6673 18.1098 60 18.9474 60H22.1053C22.9428 60 23.746 59.6673 24.3382 59.0751C24.9305 58.4829 25.2632 57.6796 25.2632 56.8421V53.6842H56.8421V56.8421C56.8421 57.6796 57.1748 58.4829 57.767 59.0751C58.3592 59.6673 59.1625 60 60 60H63.1579C63.9954 60 64.7986 59.6673 65.3909 59.0751C65.9831 58.4829 66.3158 57.6796 66.3158 56.8421V31.5789L59.7474 12.6316ZM43.9579 3.15789C43.2947 1.26316 41.4947 0 39.4737 0H11.0526C9.03158 0 7.23158 1.26316 6.56842 3.15789L0 22.1053V47.3684C0 48.2059 0.332706 49.0092 0.924926 49.6014C1.51715 50.1936 2.32037 50.5263 3.15789 50.5263H6.31579C7.15332 50.5263 7.95654 50.1936 8.54876 49.6014C9.14098 49.0092 9.47368 48.2059 9.47368 47.3684V34.4526C8.89078 34.2436 8.35481 33.9216 7.89642 33.5052C7.43804 33.0889 7.06623 32.5862 6.80227 32.026C6.5383 31.4658 6.38736 30.8591 6.35807 30.2405C6.32878 29.622 6.42172 29.0037 6.63158 28.4211C7.32632 26.5263 9.06316 25.2632 11.0526 25.2632H11.2737L13.4842 18.9474H6.31579L11.0526 4.73684H44.4947L43.9579 3.15789Z" fill="#5446E4"/>
          </svg>

        //- inline-svg(
        //-   v-if="index === 1"
        //-   src="@/assets/images/home-illustration.svg"
        //-   class="insurance-image"
        //- )
        //- inline-svg(
        //-   v-if="index === 2"
        //-   src="@/assets/images/life-illustration.svg"
        //-   class="insurance-image"
        //- )
        //- inline-svg(
        //-   v-if="index === 3"
        //-   src="@/assets/images/auto-illustration.svg"
        //-   class="insurance-image"
        //- )
        //- img(
        //-   :src="getImage(insObj.ins_id)"
        //-   alt="insurance-image.svg"
        //- )
        //- svg
        //-   use(
        //-     :xlink:href="getImage(insObj.ins_id)"
        //-     href="getImage(insObj.ins_id)"
        //-   )
        .paragraph(
          :class="{ 'selected' : selectedInsurance && insObj.ins_id === selectedInsurance.ins_id }"
        )
          h3 {{ insObj.ins_name }}
          //- p {{ $t('landing.reviewQuotes') }}
      .you-selected
        p {{ selectedInsuranceName }}
      .terms-wrap
        .checkbox-wrap
          base-checkbox(
            v-model="terms"
            class="checkbox"
            :label="$t('registration.termsOfUse')"
          )
          span(
            v-if="showTermsError"
          ) {{ $t('registration.youMustAcceptTerms') }}
        .terms-text
          a(
            href="/terms/client.pdf"
            target="_blank"
          ) {{ $t('registration.terms') }}
    .button-wrap
      base-button(
        :label="$t('buttons.getQuotes')"
        :left-icon="globalMixin_images.popupText"
        aqua
        @click="goToRegisterPage"
        id="confirmBtn"
      )
  .img-wrap(
    :style="{'background-image': 'url(' + getImage(imgId) + ')'}"
  )
    //- img(
    //-   :src="globalMixin_images.landingUserRegistrationImage"
    //-   alt="landing-user-registration-image.svg"
    //- )
</template>

<script>

export default {
  props: {
    insuranceTypes: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      localInsurances: [],
      selectedInsurance: null,
      landingImage: {},
      imgId: null,
      terms: false,
      showTermsError: false,
    };
  },
  created () {
    this.init();
  },
  computed: {
    selectedInsuranceName () {
      if (this.selectedInsurance) return this.$t('landing.youSelected') + " " + this.selectedInsurance.ins_name;
      else return this.$t('landing.selectInsurance');
    },
  },
  methods: {
    init () {
      this.localInsurances = JSON.parse(JSON.stringify(this.insuranceTypes)).map(insObj => {
        insObj.selected = false;
        return insObj;
      });
    },
    setSelectedInsurance (insObj) {
      this.selectedInsurance = insObj;
      this.imgId = insObj.ins_id;
      // scroll to confirm button
      document.getElementById('confirmBtn').scrollIntoView({behavior: "smooth"});
    },
    getImage (insId) {
      switch (insId) {
        case 1:
          return this.globalMixin_images.homeInsuranceImage;
        case 2:
          return this.globalMixin_images.lifeInsuranceImage;
        case 3:
          return this.globalMixin_images.autoInsuranceImage; 
        default:
          return this.globalMixin_images.landingAgentRegistrationImage;
      }
    },
    goToRegisterPage () {
      if(this.terms) {
        this.$router.push({ name: 'Register', params: { insuranceTypeId : this.selectedInsurance.ins_id } });
      } else {
        this.showTermsError = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-user-registration {
  display: flex;
  background: #EFEFF8;
  border-radius: 10px;
  overflow: hidden;
  > * {
    flex-basis: 100%;
  }
  .form {
    display: flex;
    flex-direction: column;
    // gap: 3em;
    @include flex-gap(3em, 'column nowrap');
    // uncomment for gap
    margin: 1em 0;
    padding: 3em;
    > p {
      margin: 0;
      color: #172856;
      font-family: 'Inter';
      font-size: clamp(2.5em, 3vw, 3.3em);
      line-height: 1.1;
    }
    .insurances-wrap {
      display: flex;
      flex-direction: column;
      // gap: 2em;
      @include flex-gap(2em, 'column nowrap');
      // uncomment for gap
      margin: 2em 0;
      .insurance-card {
        display: flex;
        align-items: center;
        cursor: pointer;
        height: 110px;
        width: 415px;
        img {
          width: 70px;
          height: 70px;
          // object-fit: cover;
        }
        .svg-holder {
          width: 200px;
          height: 100%;
          border: 1px solid #E0E3F0;
          border-right: none;
          display: flex;
          justify-content: center;
          align-items: center;
          svg {
            path {
              fill: #5446E4;
            }
          }

          &.selected {
            transition: all .2s ease;
            background: #5446E4;
            border: 1px solid #5446E4;
            border-right: none;
            svg {
              path {
                fill: #FFF;
              }
            }
          }
        }
        .paragraph {
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          border: 1px solid #E0E3F0;
          width: 100%;
          height: 100%;
          padding: 1em;
          border-left: none;
          font-family: 'Open Sans';
          font-size: .9em;
          &.selected {
            transition: all .2s ease;
            background: #5446E4;
            border: 1px solid #5446E4;
            border-left: none;
            p, h3 {
              color: #FFF;
            }
          }
          h3, p {
            margin: 0;
            color: #6F7486CC;
            font-size: 1em;
          }
          h3 {
            color: #6F7486;
            font-weight: 600;
            font-size: 1.5em;
          }
          p {
            font-style: italic;
          }
        }
      }
      .you-selected {
        p {
          margin: 0;
          color: #5446E4;
          font-size: .8em;
          font-style: italic;
          font-weight: 600;
          font-family: 'Open Sans';
        }
      }
      .terms-wrap{  
        display: flex;
        align-items: center;
        justify-content: space-between;
        .checkbox-wrap {
          position: relative;
          .checkbox {
            height: 2.5em;
          }
          span {
            display: flex;
            flex-direction: column;
            // gap: .3em;
            @include flex-gap(.3em, 'column nowrap');
            position: absolute;
            bottom: -1.5em;
            margin: 0;
            color: $input-error-msg-color;
            font-size: .9em;
            font-style: italic;
            font-family: 'Open Sans';
            font-weight: 600;
            white-space: nowrap;
            padding-left: .5em;
          }
          
        }
        .terms-text{
          display: flex;
          align-items: center;
          a {
            text-decoration: none;
            color: $main-blue;
            font-weight: bold;
          }
        }
      }
    }
    .button-wrap {
      button {
        min-width: 12em;
      }
    }
  }
  .img-wrap {
    // background-image: url("../../assets/images/landing-user-registration-image.png");
    background-repeat: no-repeat;
    background-size: cover;
    width: 600px;
    img {
      min-height: 100%;
    }
  }
}

@media (max-width: 1250px) {
  .landing-user-registration {
    .form{
      .insurances-wrap{
        .insurance-card{
          img{
            width: 15em;
          }
        }
      }
    }
    .img-wrap {
      flex-basis: 80%;
    }
  }
}

@media (max-width: 900px) {
  .landing-user-registration {
    .form{
      .insurances-wrap{
        .insurance-card{
          img{
            width: 16em;
          }
        }
      }
    }
    .img-wrap {
      flex-basis: 40%;
    }
  }
}

@media (max-width: 768px) {
  .landing-user-registration {
    .form {
      padding: 2em;
    }
    .img-wrap {
      display: none;
    }
  }
}

@media (max-width: 550px) {
  .landing-user-registration {
    .form {
      padding: 1em;
      p {
        text-align: center;
        font-size: 2em;
        margin-top: 15px;
      }
      .insurances-wrap {
        .insurance-card {
          flex-direction: column;
          height: 90px;
          width: 100%;
          border: 1px solid $button-text-disabled;
          img {
            display: none;
          }
          .paragraph {
            width: 100%;
            padding-top: 0;
            padding-bottom: 0;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
}

/* Safari 11+ */
@media not all and (min-resolution:.001dpcm)
{ @supports (-webkit-appearance:none) and (stroke-color:transparent) {
  .landing-user-registration {
    .form {
      > p {
        font-size: 3vw;
      }
    }
  }
}}
</style>